import { render, staticRenderFns } from "./CsvImportTreatments.vue?vue&type=template&id=bb7e442c&scoped=true&"
import script from "./CsvImportTreatments.vue?vue&type=script&lang=js&"
export * from "./CsvImportTreatments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7e442c",
  null
  
)

export default component.exports